import { render, staticRenderFns } from "./dapp-box1.vue?vue&type=template&id=59782412&scoped=true&"
import script from "./dapp-box1.vue?vue&type=script&lang=js&"
export * from "./dapp-box1.vue?vue&type=script&lang=js&"
import style0 from "./dapp-box1.vue?vue&type=style&index=0&id=59782412&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59782412",
  null
  
)

export default component.exports